<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">The book I got was not what I ordered</h1>

			<div v-if="other_item">
				<div v-if="!submitted">
					<p>
						Please enter the ISBN of the book you received, it is on the title page or the back cover of the book. Do not remove any stickers.
					</p>

					<div>
						<v-text-field label="ISBN" v-model="isbn" mask="#########N###" :rules="isbn_rules" counter="13" solo flat :error-messages="error_messages" @focus="error_messages = []"></v-text-field>

						<v-btn color="#7DADED" large round dark @click="submit">Submit</v-btn>
					</div>
				</div>
				<div v-else-if="bundles_items.length > 0">
					<p>
						Hey, We noticed the ISBN you entered is a component of the bundle you ordered. Did you check for these components?
					</p>
					<ul>

						<ul class="h-bundle-components">
							<li v-for="comp in bundles_items">
								<v-flex xs12>
									<v-card color="" class="">
										<v-layout>
											<v-flex xs2>
												<v-img
														:src="comp.cover"
														height="90px"
														contain
														class="mt-2"
												></v-img>
											</v-flex>
											<v-flex xs10>
												<v-card-title primary-title>
													<div>
														<div class="">{{ comp.title }}</div>
														<div>{{ comp.author }}</div>
														<div>{{ comp.isbn }}</div>
													</div>
												</v-card-title>
											</v-flex>
										</v-layout>
										<v-divider light></v-divider>
									</v-card>
								</v-flex>
							</li>
						</ul>
					</ul>
				</div>
				<div v-else>
					<p>
						Thanks for submitting your report. We will be in touch!
					</p>
				</div>
			</div>

			<div v-if="mp_item">
				<p>
					Contact the MP seller using <a
						:href="`/account/new_messages.php?action=thread&type=postsale&item_id=${parseInt($route.params.id)}#lastmessage`">this link</a>,
					and let them know there was an issue.
				</p>

				<p>
					If the seller doesn't reply to you within a couple of days, contact customer service and let us know. You can use this form:
				</p>

				<email-form
						subject="The book I got was not what I ordered"
						:body="email_body"
						on-success-url="/help?#/submitted"
						edit-body
						class="h-email"
						:payload="{ order_line_id }"
						destination-key="cs"
				></email-form>
			</div>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../../components/BaseNavLinks';
	import EmailForm from './../../../components/EmailForm';
	import Axios from 'axios';

	export default {
		name: "WrongItemReceived",

		components: {
			BaseNavLinks,
			EmailForm
		},

		data() {
			return {
				order_line_id: null,
				other_item: false,
				mp_item: false,
				submitted: false,
				isbn: '',
				bundles_items: [],
				error_messages: [],
				isbn_rules: [v => v.length == 10 || v.length == 13 || 'Must be 10 or 13 digits']
			}
		},

		computed: {
			email_body() {
				return 'I contacted the seller to report that the book I got was not what I ordered, but they didn\'t respond.'
			},
		},

		mounted() {
			const self = this;
			self.loading = true;

			self.order_line_id = parseInt(self.$route.params.id);

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_product_detail/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data) {
						if (!_.isUndefined(response['data']['data']['product_type']) && response['data']['data']['product_type'] == 'marketplace') {
							self.mp_item = true;
						} else {
							self.other_item = true;
						}
					}
				})
				.finally(function () {
					self.loading = false;
				});
		},

		methods: {
			submit() {
				const self = this;
				self.loading = true;

				if (!self.isbn) {
					self.error_messages.push("ISBN can't be empty");
					return;
				}

				if (self.isbn.length != 10 && self.isbn.length != 13) {
					return;
				}

				self.loading = true;

				Axios.post('/service/customer_help/rest/index.php/customer_help/replace_item_in_order/', {
					order_line_id: parseInt(self.$route.params.id),
					wrong_isbn: self.isbn,
				})
					.then(function (response) {
						if (response.status === 200 && response.data && response.data['status'] === 'success') {
							self.submitted = true;
							if (response['data']['data']['is_wrong_isbn_a_bundle_component']) {
								self.bundles_items = response['data']['data']['bundles_items'];
							}
						}
					})
					.finally(function () {
						self.loading = false;
					});

			},
		}
	}
</script>

<style scoped lang="less">
	ul.h-bundle-components {
		padding: 0;

		> li {
			list-style: none;
		}
	}
	.h-email {
		margin-top: 10px;
	}
</style>